import Image from 'components/generic/Image';
import imageOverlayStyle from 'components/shared/style/imageOverlay';
import styled from 'styled-components';
import DiagonalLines from 'components/product/Variants/Swatches/DiagonalLines';

type ProductImageProps = {
    image: string;
    unavailable: boolean;
};

const Wrapper = styled.div`
    position: relative;
    display: block;
    width: 56px;
    height: 72px;
    border: 1px solid ${({ theme }) => theme.ColorBorderDefault};
    padding: ${({ theme }) => theme.Spacing2};
    background: ${({ theme }) => theme.ColorBackgroundPrimary};

    &:before {
        content: '';
        ${imageOverlayStyle}
    }
`;

const Img = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export default function ProductImage({ image, unavailable, ...restProps }: ProductImageProps) {
    if (!image) return null;

    return (
        <Wrapper {...restProps}>
            <Img src={image} sizes={56} alt={''} transformType="SquareScale" imageType="product" />
            {unavailable && <DiagonalLines size="lg" />}
        </Wrapper>
    );
}
